import AppContent from "./index.vue";
import Vue from "vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  render(createElement) {
    return createElement(AppContent, this.$slots.default);
  }
});
